export default __webpack_public_path__ + "images/red-card.png";